import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'الرئيسية', href: '#hero' },
    { name: 'من نحن', href: '#about' },
    { name: 'المميزات', href: '#features' },
    { name: 'القوائم', href: '#menu' },
    { name: 'المعرض', href: '#gallery' },
    { name: 'الموقع', href: '#location' },
    { name: 'حجز طاولة', href: '#reservation' }
  ];

  // Menu dropdown items
  const menuDropdownItems = [
    { name: 'بوفيه الفطور', href: '/breakfast' },
    { name: 'الغداء والعشاء', href: '/lunch-dinner' },
    { name: 'الكافي والمشروبات', href: '/beverages' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg backdrop-blur-md' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/f42e20f23ee10135ebb8bc87eaeeb99a.png"
                alt="Focaccia Restaurant"
                className="h-16 w-auto object-contain"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="flex items-center space-x-8">
              {navLinks.map((link, index) => (
                <div key={index} className="relative group">
                  {link.name === 'القوائم' ? (
                    <div className="relative">
                      <button className={`px-4 py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 flex items-center gap-2 cursor-pointer whitespace-nowrap ${
                        scrolled ? 'text-gray-700' : 'text-white'
                      }`}>
                        {link.name}
                        <i className="ri-arrow-down-s-line"></i>
                      </button>
                      
                      {/* Dropdown Menu */}
                      <div className="absolute top-full right-0 mt-2 w-56 bg-white rounded-2xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                        <div className="py-4">
                          {menuDropdownItems.map((item, itemIndex) => (
                            <a
                              key={itemIndex}
                              href={item.href}
                              className="block px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors duration-200 font-medium cursor-pointer whitespace-nowrap"
                              style={{ fontFamily: 'Cairo, sans-serif' }}
                            >
                              {item.name}
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <a
                      href={link.href}
                      className={`px-4 py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer whitespace-nowrap ${
                        scrolled ? 'text-gray-700' : 'text-white'
                      }`}
                    >
                      {link.name}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className={`p-2 rounded-md transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
              }`}
            >
              <i className={`text-2xl ${isOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white rounded-b-2xl shadow-lg">
              {navLinks.map((link, index) => (
                <div key={index}>
                  {link.name === 'القوائم' ? (
                    <div>
                      <div className="block px-3 py-2 text-base font-medium text-gray-700 border-b border-gray-200">
                        {link.name}
                      </div>
                      {menuDropdownItems.map((item, itemIndex) => (
                        <a
                          key={itemIndex}
                          href={item.href}
                          className="block px-6 py-2 text-sm text-gray-600 hover:text-teal-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                          onClick={() => setIsOpen(false)}
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  ) : (
                    <a
                      href={link.href}
                      className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-teal-600 hover:bg-teal-50 rounded-md transition-colors duration-200 cursor-pointer whitespace-nowrap"
                      onClick={() => setIsOpen(false)}
                    >
                      {link.name}
                    </a>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
